import { render, staticRenderFns } from "./vBookDemoRequestModal.vue?vue&type=template&id=395d0312&scoped=true"
import script from "./vBookDemoRequestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vBookDemoRequestModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vBookDemoRequestModal.vue?vue&type=style&index=0&id=395d0312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d0312",
  null
  
)

export default component.exports